<script setup lang="ts">
import merge from 'lodash-es/merge';
import BannerGroupsService from '#layers/cms/app/pages/cms/marketing/banners/_runtime/services/BannerGroupsService';
import type { ListItemModel } from '#layers/cms/app/pages/cms/marketing/banners/_runtime/services/BannerGroupsService';

defineOptions({
    name: 'WidgetBannersSettings'
});

const emit = defineEmits<{
    (e: 'update:modelValue', payload: any): void;
}>();

const props = defineProps<{
    modelValue: any;
}>();

const defaults = ref<any>({
    bannerGroupId: ''
});

const form = computed<any>(() =>
{
    return props.modelValue;
});

function triggerModel(): void
{
    emit('update:modelValue', form.value);
}

async function fetchSlider(id: number): Promise<ListItemModel>
{
    const response = await BannerGroupsService.fetchAutocompleteModel(id);

    return response.first();
}

async function searchSliders(query: string, limit: number): Promise<ListItemModel[]>
{
    return await BannerGroupsService.getAutocompleteList(query, limit, false);
}

watch(() => form.value.settings, () =>
{
    triggerModel();
}, { deep: true });

onBeforeMount(async (): Promise<void> =>
{
    form.value.settings = merge(defaults.value, form.value.settings);
});
</script>

<template>
    <IdeoFormGroup :label="$t('[[[Grupa]]]')" :invalid-feedback="form.$errors.first('settings.bannerGroupId')" :state="form.$errors.state('settings.bannerGroupId')" required>
        <IdeoAutocomplete
            v-model="form.settings.bannerGroupId"
            name="settings.bannerGroupId"
            track-by="id"
            :placeholder="$t('[[[zacznij pisać aby wyszukać grupę...]]]')"
            :fetch="(id: number) => fetchSlider(id)"
            :search="(query: string, limit: number) => searchSliders(query, limit)"
            :disabled="form.language === null"
        >
            <template #selected="{ option }">
                <div class="text-wrap">
                    {{ option.name }}
                </div>
            </template>
            <template #option="{ option }">
                <div class="text-wrap">
                    {{ option.name }}
                </div>
            </template>
        </IdeoAutocomplete>
    </IdeoFormGroup>
</template>
